import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allBlopedFechasAction,
  setActivoBlopedFechasAction,
} from './BlopedFechasAction';
import FormBlopedFechas from './components/FormBlopedFechas';
import ListadoBlopedFechas from './components/ListadoBlopedFechas';

const BlopedFechasView = () => {
  const dispatch = Redux.useDispatch();

  const blopedFechasStore = Redux.useSelector((state) => state.blopedFechas);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12} sx={{ display: 'flex', m: 1 }}>
        <BotonComponent
          click={async () => {
            await setActivoBlopedFechasAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          addIcon
          mr={2}
        />
        <BotonComponent
          click={async () => {
            await setActivoBlopedFechasAction(dispatch, null);
            await allBlopedFechasAction(dispatch, blopedFechasStore.params);
          }}
          disabled={
            blopedFechasStore.loadingAll || blopedFechasStore.all.length === 0
          }
          white
          refreshIcon
          text={blopedFechasStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoBlopedFechas
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Grid>
      <ModalComponent
        id="modalFormBlopedFechas"
        title={`${
          blopedFechasStore.activo
            ? `Editar ${blopedFechasStore.activo.periodoAcademico.desde}-${blopedFechasStore.activo.periodoAcademico.hasta} (${blopedFechasStore.activo.periodoAcademico.nombre})`
            : 'Nueva fecha del momento'
        }`}
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormBlopedFechas
          activo={blopedFechasStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default BlopedFechasView;
